// The single place dayjs plugins and locales are registered (INS-1611),
// mirroring the setupHighcharts.ts precedent. App code imports the configured
// instance from "~/utils/dayjs" — never from bare "dayjs" (lint-enforced) —
// so any module (including unit tests importing it in isolation) gets the
// plugins registered. Evaluates once; main.tsx also imports it eagerly.
//
// The six plugins the INS-1611 migration audit found in use, plus the two
// the audit missed: the `w` week-of-year FORMAT token (DateFormatWeekOnly
// "[Week] w, YYYY", DateFormat.BOOKINGS_LABEL) is a core token in Moment but
// needs advancedFormat + weekOfYear in dayjs. Every `w` call site formats an
// isoWeek Monday, for which dayjs's week() matches Moment's rendering under
// the old WeekPicker dow:1 locale hack exactly (verified for every Monday
// 2020–2030). Do not add more (timezone, relativeTime, duration,
// localizedFormat, ...) without a real call site.
/* eslint-disable no-restricted-imports -- the one module allowed to import bare "dayjs" */
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isoWeek from "dayjs/plugin/isoWeek";
import utc from "dayjs/plugin/utc";
import weekOfYear from "dayjs/plugin/weekOfYear";

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(weekOfYear);

export type { Dayjs } from "dayjs";
export default dayjs;
